<script>
	import client from "src/services/client";
	import { errorMessage, jobAction, modalOpen } from "src/store/store";
	import {
		extractErrorMessage,
		splitCamelCaseAndCapitalize,
	} from "src/utils/misc";
	import { afterUpdate, onMount } from "svelte";
	import { field, form } from "svelte-forms";
	import { required } from "svelte-forms/validators";
	import {
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import { handleJob } from "../../views/JobManagement/JobConfirmation";
	import CustomButton from "../CustomButton/CustomButton.svelte";
	import CustomSelect from "../CustomSelect/CustomSelect.svelte";
	import ErrorMessageHandler from "../ErrorMessageHandler/ErrorMessageHandler.svelte";

	export let fetchData;
	export let jobId;

	let err;
	let open = false;
	let action = "";
	let actionReasonOptions = {};

	async function getJobReasons() {
		try {
			const res = await client(`/v1/Jobs/lookups`, {
				version: "Tasking",
			});
			if (res.status === 200) {
				actionReasonOptions.complete =
					res.data.reasonLookups.completionReasons.map((val) => {
						return {
							id: val.id,
							name: val.text,
						};
					});
				actionReasonOptions.delete =
					res.data.reasonLookups.deletionReasons.map((val) => {
						return {
							id: val.id,
							name: val.text,
						};
					});
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
		}
	}

	modalOpen.subscribe((value) => {
		open = value;
	});

	jobAction.subscribe((value) => {
		action = value;
	});

	errorMessage.subscribe((value) => {
		err = value;
	});

	const reason = field("reason", "", [required()]);
	const myForm = form(reason);

	const toggle = () => {
		modalOpen.set(false);
		errorMessage.set("");
	};

	const handleSubmit = async () => {
		await handleJob(action, $reason.value, fetchData);
	};

	onMount(() => {
		// getJobReasons();
	});

	afterUpdate(() => {
		if (!open) {
			myForm.reset();
		}
	});

	$: if (open) {
		getJobReasons();
	}
</script>

<Modal isOpen={open} backdrop centered {toggle} size="md">
	<ModalHeader {toggle}>
		<b>
			{splitCamelCaseAndCapitalize(action)} job
		</b>
	</ModalHeader>
	<ModalBody>
		<ErrorMessageHandler message={err} />
		<div style="margin-bottom: 32px;">
			<span
				>Are you sure you want to {action} job? Select a reason to proceed.</span
			>
		</div>
		<CustomSelect
			bind:value={$reason.value}
			options={actionReasonOptions[action]}
			defaultOption="Select a reason"
			error={$myForm.hasError("reason.required")}
			errorText="Please select a reason"
		/>
	</ModalBody>
	<ModalFooter>
		<CustomButton
			buttonText="Cancel"
			on:click={toggle}
			onKeyDown={handleSubmit}
		/>
		<CustomButton
			buttonText={splitCamelCaseAndCapitalize(action) + " job"}
			on:click={handleSubmit}
			disabled={$myForm.hasError("reason.required") || !$reason.value}
			color="danger"
			onKeyDown={handleSubmit}
		/>
	</ModalFooter>
</Modal>

<style>
	@media (min-width: 576px) {
		:global(.modal-md) {
			max-width: 600px !important;
			margin: 1.75rem auto;
		}
	}
</style>
